import React from 'react';
import { useTranslation, resolveResourceLang } from './i18n.js';
import { CollapsibleCard } from './collapsible.js';

export function Oma({ initialData }) {
  const { lang, t } = useTranslation();
  const [html, setHtml] = React.useState(initialData ? initialData.html : '');
  const [loading, setLoading] = React.useState(!initialData);
  const [error, setError] = React.useState('');

  React.useEffect(() => {
    if (initialData) {
      return;
    }

    setLoading(true);
    setError('');

    const resourceLang = resolveResourceLang(lang);

    fetch(`/resources/${resourceLang}/oma.html`)
      .then((response) => {
        if (!response.ok) {
          throw new Error('Impossible de charger le contenu.');
        }
        return response.text();
      })
      .then((text) => {
        setHtml(text);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message || t('contentErrorLoad'));
        setLoading(false);
      });
  }, [lang]);

  return (
    <CollapsibleCard id="oma" className="oma-card" label={t('editoTocAuthor')}>
      {loading && (
        <div className="loading">
          <progress />
          <p>{t('contentLoading')}</p>
        </div>
      )}
      {error && (
        <div className="error">
          <strong>{t('contentErrorPrefix')}</strong> {error}
        </div>
      )}
      {!loading && !error && (
        <div className="oma-content" dangerouslySetInnerHTML={{ __html: html }} />
      )}
    </CollapsibleCard>
  );
}
